import { defineMessages } from 'react-intl'

export default defineMessages({
  noResultsQuery: {
    id: 'containers.CustomerBillingPage.noResultsQuery',
    defaultMessage: 'No results for ',
  },
  noResultsFilters: {
    id: 'containers.CustomerBillingPage.noResultsFilters',
    defaultMessage: 'No results with selected filters',
  },
  of: {
    id: 'containers.CustomerBillingPage.of',
    defaultMessage: 'of',
  },
  edit: {
    id: 'containers.CustomerBillingPage.edit',
    defaultMessage: 'Edit',
  },
  requestHelp: {
    id: 'containers.CustomerBillingPage.requestHelp',
    defaultMessage: 'Request help',
  },
})
